import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, Links } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const webPeduliTabs = [
  { label: "Peduli Sumatera", value: "sumatera" },
  { label: "Peduli Yatim", value: "yatim" },
  { label: "Peduli Lansia", value: "lansia" },
  { label: "Peduli Palestina", value: "palestina" },
  { label: "Peduli Sudan", value: "sudan" },
];

const VideoTable = () => {
  const [videoList, setVideoList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState<any>(null);
  const [webPeduli, setWebPeduli] = useState("sumatera"); // WAJIB ADA
  const [selectedVideo, setSelectedVideo] = useState<any>(null);

  const fetchVideo = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE}/api/video`, {
        params: {
          page,
          web_peduli: webPeduli,
        },
      });

      setVideoList(res.data.data);
      setPagination(res.data.pagination);
    } catch (err) {
      console.error("Gagal ambil video:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVideo();
  }, [page, webPeduli]);

  return (
    <div className="mt-6">
      {/* HEADER */}
      <div className="flex flex-col gap-4 mb-4">
        <h2 className="text-2xl font-bold text-orange-600">Manajemen Video</h2>

        {/* TAB */}
        <div className="flex justify-between items-center">
          <div className="flex flex-wrap gap-2">
            {webPeduliTabs.map((tab) => (
              <button
                key={tab.value}
                onClick={() => {
                  setPage(1);
                  setWebPeduli(tab.value);
                }}
                className={`px-4 py-2 rounded-lg text-sm border transition
                ${webPeduli === tab.value ? "bg-orange-500 text-white border-orange-500" : "bg-white text-gray-600 hover:bg-orange-100"}`}>
                {tab.label}
              </button>
            ))}
          </div>

          <Link to="/dashboard/video/tambah" className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm">
            + Tambah Video
          </Link>
        </div>
      </div>

      {/* TABLE */}
      <div className="overflow-x-auto bg-white rounded-xl shadow border">
        <table className="min-w-full text-sm">
          <thead className="bg-orange-500 text-white">
            <tr>
              <th className="p-3 text-left">Judul</th>
              <th className="p-3 text-left">Video</th>
              <th className="p-3 text-left">Web Peduli</th>
              <th className="p-3 text-left">Tanggal Dibuat</th>
              <th className="p-3 text-left">Aksi</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="p-4 text-center">
                  Loading...
                </td>
              </tr>
            ) : videoList.length === 0 ? (
              <tr>
                <td colSpan={5} className="p-4 text-center text-gray-500">
                  Tidak ada data
                </td>
              </tr>
            ) : (
              videoList.map((item) => (
                <tr key={item.id} className="border-t hover:bg-orange-50 transition">
                  <td className="p-3 font-medium text-gray-800">{item.judul}</td>

                  <td className="p-3">
                    <div onClick={() => setSelectedVideo(item)} className="cursor-pointer group relative w-32 h-20 rounded-md overflow-hidden border">
                      <video src={item.video_url} className="w-full h-full object-cover" muted />

                      {/* Play Icon */}
                      <div className="absolute inset-0 flex items-center justify-center bg-black/30 opacity-0 group-hover:opacity-100 transition">
                        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </td>

                  <td className="p-3">
                    <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded text-xs capitalize">{item.web_peduli}</span>
                  </td>

                  <td className="p-3">{new Date(item.created_at).toLocaleDateString()}</td>

                  <td className="p-3">
                    <Link to={`/dashboard/video/detail/${item.id}`} className="text-orange-600 hover:underline">
                      Detail
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      {pagination && (
        <div className="flex justify-between items-center mt-4 text-sm">
          <span className="text-gray-600">
            Page {pagination.current_page} dari {pagination.last_page} | Total {pagination.total}
          </span>

          <div className="flex gap-2">
            <button disabled={page === 1} onClick={() => setPage(page - 1)} className="px-3 py-1 rounded border disabled:opacity-50 hover:bg-orange-100">
              Prev
            </button>

            <button disabled={page === pagination.last_page} onClick={() => setPage(page + 1)} className="px-3 py-1 rounded border disabled:opacity-50 hover:bg-orange-100">
              Next
            </button>
          </div>
        </div>
      )}

      {selectedVideo && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center">
          <div className="bg-white rounded-xl w-full max-w-3xl p-4 relative">
            <button onClick={() => setSelectedVideo(null)} className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl">
              ✕
            </button>

            <video src={selectedVideo.video_url} controls autoPlay className="w-full h-[100vh] rounded-lg" />
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoTable;
